import { InClauseUnderConjunction } from './in-clause-under-conjunction';
import head from 'lodash-es/head';
export function getAppropriatePlugin(parent, queryParam, options) {
    const plugins = [
        new InClauseUnderConjunction(parent, queryParam, options)
    ];
    return head(plugins.filter(plugin => plugin.isMatched()));
}
//# sourceMappingURL=index.js.map